import { useQuery } from '@tanstack/react-query'
import api from '@/api/axiosApi'
import { queryKeys } from '@/lib/queryKeys'
import type { PaginationMeta } from '@/types'
import type { UserRead } from '@/api/shares'

interface PaginatedUsersResponse {
  data: UserRead[]
  pagination: PaginationMeta
}

async function fetchAllUsers(): Promise<UserRead[]> {
  const response = await api.get<PaginatedUsersResponse>('/admin/users', {
    params: { limit: 200 },
  })
  return response.data.data
}

export function useAllUsers() {
  return useQuery({
    queryKey: queryKeys.users.all,
    queryFn: fetchAllUsers,
    staleTime: 5 * 60 * 1000,
  })
}
